export default function setHtmlLangAttribute(currentLanguage) {
  document.documentElement.lang = currentLanguage;
}
